import { useCallback, useRef } from 'react';
import type { RefObject } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

export function useTrackCommentsImpression(containerRef: RefObject<HTMLElement | null>, enabled: boolean): () => void {
	const trackedRef = useRef(false);
	const track = useTracking();

	return useCallback(() => {
		if (!enabled || trackedRef.current) return;

		if (containerRef.current) {
			trackedRef.current = true;
			void track('petition_comments_view');
		}
	}, [containerRef, enabled, track]);
}
